import React from 'react';
import { DEMO_CONFIG, isDemoMode } from '../utils/demo';
import './DemoBanner.css';

function DemoBanner() {
  if (!isDemoMode()) return null;

  return (
    <div className="demo-banner" role="note">
      <div className="demo-banner__inner">
        <span className="demo-banner__label">DEMO</span>
        <span className="demo-banner__text">
          これは民泊管理システムのデモ環境です。データはサンプルです。
          ログイン情報: <code>{DEMO_CONFIG.username}</code> / <code>{DEMO_CONFIG.password}</code>
        </span>
        <a
          className="demo-banner__cta"
          href={DEMO_CONFIG.contactUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          お問い合わせ →
        </a>
      </div>
    </div>
  );
}

export default DemoBanner;
